// extracted by mini-css-extract-plugin
export default {"header":"PO-z","isActive":"QO-z"};